import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import {
  Layout,
  Modal,
  Button,
  Avatar,
  Row,
  Col,
  Popover,
  Divider,
  Space,
  Typography,
  Input,
  Card,
  List,
} from 'antd';
import {
  MenuFoldOutlined,
  ExclamationCircleOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { isMobile } from 'react-device-detect';
// actions
import { logout } from '../redux/actions/AuthActions';
import AppDrawer from './AppDrawer';
import IntlMessages from '../components/IntlMessage';
import { injectIntl } from 'react-intl';
import { debounce } from 'lodash';
import orderApi from '../api/order';
import dayjs from 'dayjs';
import cacheApi from '../api/cache';
import { rateUsd } from '../utils/constant';
import Currency from '../components/Currency';

const { Text } = Typography;
const { Header } = Layout;
const { confirm } = Modal;

function AppHeader() {
  const [visible, setVisible] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const authUser = useSelector((state) => state.auth.authUser);
  const config = useSelector((state) => state.config);
  const dispatch = useDispatch();
  const isMount = useRef(false);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCache, setLoadingCache] = useState(false);
  const [total, setTotal] = useState(1);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    keyword: '',
    order_by: 'id',
    order_dir: 'DESC',
  });

  // side effects
  useEffect(() => {
    isMount.current = true;
    if (isMount) {
      setLoading(true);
      if (filter.keyword.length > 1) {
        Promise.all([orderApi.getAll(filter)])
          .then((res) => {
            const orderData = res[0]?.data;
            if (Array.isArray(orderData)) {
              setOrders(orderData);
            }
            if (total !== res[0].total) {
              setTotal(res[0].total);
            }
            setLoading(false);
          })
          .catch((error) => {
            console.error(error);
            setLoading(false);
          });
      } else {
        setOrders([]);
        setLoading(false);
      }
    }

    return () => {
      isMount.current = false;
    };
  }, [filter]);

  useEffect(() => {
    if (filter.keyword?.length > 1) {
      if (!isSearching) {
        setIsSearching(true);
      }
    } else {
      setIsSearching(false);
    }
  }, [filter]);

  const toggleDrawer = (visible) => {
    setVisible(visible);
  };

  const onLogout = () => {
    confirm({
      title: 'Are you sure to log out?',
      icon: <ExclamationCircleOutlined />,
      okText: 'OK',
      cancelText: 'Cancel',
      onOk: () => {
        dispatch(logout()).then(() => {
          window.location.href = '/login';
        });
      },
    });
  };

  const prefix = (
    <SearchOutlined
      style={{
        fontSize: 16,
        color: '#1890ff',
      }}
    />
  );

  const handleChangeSearch = debounce(async (e) => {
    setFilter((filter) => {
      return { ...filter, keyword: e.target.value };
    });
  }, 300);

  const onChangePagination = (page, pageSize) => {
    // console.log(pageSize);
    setFilter({
      ...filter,
      page,
      limit: pageSize,
    });
  };

  const onClose = () => {
    setIsSearching(false);
  };

  const onFocus = debounce(() => {
    if (filter.keyword?.length > 1) {
      if (!isSearching) {
        setIsSearching(true);
      }
    } else {
      setIsSearching(false);
    }
  }, 500);

  const handleResetCache = () => {
    setLoadingCache(true);
    cacheApi
      .reset()
      .then(() => {
        setLoadingCache(false);
      })
      .catch((error) => {
        console.error(error);
        setLoadingCache(false);
      });
  };

  return (
    <Header className="site-header-background">
      <Row justify="space-between">
        <Col></Col>,
        <Col>
          <Row align="middle" justify="space-between">
            <Col>
              {/* <Text style={{ color: '#fff' }}>
                Usd/Vnd:{' '}
                {new Intl.NumberFormat('vi', {
                  style: 'currency',
                  currency: 'vnd',
                  minimumFractionDigits: 0,
                }).format(rateUsd.vnd * 1000)}
              </Text>
              <Divider type="vertical" style={{ height: '1.5em' }}></Divider> */}
            </Col>
            <Col>
              <Button
                type="primary"
                shape="round"
                loading={loadingCache}
                onClick={handleResetCache}>
                <IntlMessages id="global.cache_reset" />
              </Button>
              <Divider type="vertical" style={{ height: '1.5em' }}></Divider>
            </Col>

            <Col>
              <Row align="middle">
                {/* <Input
                  placeholder="Search..."
                  size="large"
                  prefix={prefix}
                  onChange={handleChangeSearch}
                  style={{
                    position: 'relative',
                    zIndex: '1000',
                  }}
                  allowClear
                  onFocus={onFocus}
                /> */}
              </Row>
              {isSearching && orders.length > 0 && (
                <React.Fragment>
                  <Card
                    title={<IntlMessages id="global.orders" />}
                    style={{
                      position: 'absolute',
                      top: 'calc(100% + 6px)',
                      right: '0',
                      zIndex: '1000',
                      boxShadow: '1px 2px 5px #eee',
                    }}>
                    <List
                      style={{
                        minWidth: '600px',
                      }}
                      pagination={{
                        size: 'small',
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50'],
                        total: total,
                        current: filter.page,
                        pageSize: filter.limit,
                        onChange: onChangePagination,
                      }}
                      loading={loading}
                      dataSource={orders}
                      renderItem={(order, i) => (
                        <List.Item>
                          <List.Item.Meta
                            title={
                              <Link
                                to={`/app/orders/details/${order.id}`}
                                onClick={() => setIsSearching(false)}>
                                {order.order_no}
                              </Link>
                            }
                            description={<OrderItem order={order} />}
                          />
                        </List.Item>
                      )}
                    />
                  </Card>
                  <div
                    style={{
                      position: 'fixed',
                      top: '0',
                      bottom: '0',
                      right: '0',
                      left: '0',
                      // backgroundColor: 'rgba(0, 0, 0, 0.45)',
                      zIndex: '950',
                    }}
                    onClick={onClose}></div>
                </React.Fragment>
              )}
            </Col>

            <Col>
              <Divider type="vertical" style={{ height: '1.5em' }}></Divider>
              {isMobile ? (
                <Button
                  type="link"
                  icon={<MenuFoldOutlined className="header-icons" />}
                  onClick={() => toggleDrawer(true)}
                />
              ) : (
                <React.Fragment>
                  <Popover
                    trigger="click"
                    className="header-actions"
                    placement="bottomRight"
                    content={
                      <>
                        <Row gutter={[20, 20]}>
                          <Col>
                            <Row align="middle" justify="space-around">
                              {authUser.image ? (
                                <Avatar src={authUser.image} />
                              ) : (
                                <Avatar style={{ backgroundColor: '#f56a00' }}>
                                  {authUser.lastname.charAt(0)}
                                </Avatar>
                              )}
                            </Row>
                          </Col>
                          <Col>
                            <Text strong>
                              {authUser.lastname + ' ' + authUser.firstname}
                            </Text>
                            <br></br>
                            <Text style={{ fontSize: '12px' }} type="secondary">
                              {authUser.email}
                            </Text>
                          </Col>
                        </Row>
                        <Divider
                          style={{ marginTop: '10px', marginBottom: '10px' }}
                        />
                        <Link to="/app/profile">
                          <Button type="link">
                            <IntlMessages id="global.account_information" />
                          </Button>
                        </Link>
                        <Divider
                          style={{ marginTop: '10px', marginBottom: '10px' }}
                        />
                        <Button type="link" onClick={() => onLogout()}>
                          <Space>
                            <IntlMessages id="global.signout" />
                          </Space>
                        </Button>
                      </>
                    }
                    title={null}>
                    {authUser.image ? (
                      <Avatar src={authUser.image} />
                    ) : (
                      <Avatar style={{ backgroundColor: '#f56a00' }}>
                        {authUser.lastname.charAt(0)}
                      </Avatar>
                    )}
                  </Popover>
                </React.Fragment>
              )}
            </Col>
          </Row>
        </Col>
      </Row>

      <AppDrawer visible={visible} onClose={() => toggleDrawer(false)} />
    </Header>
  );
}

const OrderItem = (props) => {
  const { order } = props;
  return (
    <Row>
      <Col span={8}>
        <Text type={order.roundtrip && 'success'}>
          {order?.hop?.start_stop?.title} - {order?.hop?.end_stop?.title}
        </Text>
      </Col>
      <Col span={8}>
        <Space direction="vertical">
          <Text>{dayjs(order.date).format('ddd, MMM DD, YYYY')}</Text>
          {order?.return_date && (
            <Text>{dayjs(order.return_date).format('ddd, MMM DD, YYYY')}</Text>
          )}
        </Space>
      </Col>
      <Col span={8}>
        <Text>
          {order?.customer?.fullname}
          {order?.customer?.company_shortname &&
            ` (${order?.customer?.company_shortname})`}
        </Text>
      </Col>
    </Row>
  );
};

export default injectIntl(withRouter(AppHeader));
